import React from 'react';
import { Button, Box } from '@material-ui/core';
import { PeopleOutlined, KeyboardArrowDownRounded } from '@material-ui/icons';
import { useRosterStatusStyles } from './RosterTableStyles';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';

interface Props {
  color?: string;
  text: string;
  onClick: (arg: any) => void;
  disabled?: boolean;
  hasLeaveConflict?: boolean;
  publishedSessionIds?: string[];
}

export function RosterStatus({ text, onClick, color = 'tomato', disabled, hasLeaveConflict }: Props) {
  const classes = useRosterStatusStyles({ color });
  const { isMobile } = useCampfireTheme();

  // Determine if this is a rostered session with leave conflict
  const isRosteredWithLeaveConflict = hasLeaveConflict && text === 'Rostered';

  const displayText = isRosteredWithLeaveConflict ? 'Leave Conflict' : text;

  return (
    <Button
      onClick={onClick}
      variant='outlined'
      startIcon={
        <PeopleOutlined
          style={{
            fontSize: '18px',
          }}
        />
      }
      disabled={disabled}
      endIcon={<KeyboardArrowDownRounded style={{ fontSize: '18px' }} />}
      classes={{ root: isMobile ? classes.statusContainerMobile : classes.statusContainer }}
      style={{
        color: text === 'Unavailable' ? '#9e9e9e' : '',
        backgroundColor: isRosteredWithLeaveConflict ? '#FFAA63' : undefined,
      }}
    >
      {displayText}
    </Button>
  );
}

export function RosterCompletedStatus({ color = '#ABDC40' }: { color?: string }) {
  return <Box bgcolor={color} width='1rem' height='1rem' borderRadius='50%' margin='auto' />;
}
